var Queensland = "Queensland";
var Tasmania = "Tazmanya";
var Victoria = "Victoria";
var AUStates = {
	"Australian Capital Territory": "Avustralya Başkent Bölgesi",
	"New South Wales": "Yeni Güney Galler",
	"Northern Territory": "Kuzey Toprakları",
	Queensland: Queensland,
	"South Australia": "Güney Avustralya",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "Batı Avustralya"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
